import { render, staticRenderFns } from "./RecipesModalTableRow.vue?vue&type=template&id=4fc72036&scoped=true&lang=pug"
import script from "./RecipesModalTableRow.vue?vue&type=script&lang=js"
export * from "./RecipesModalTableRow.vue?vue&type=script&lang=js"
import style0 from "./RecipesModalTableRow.vue?vue&type=style&index=0&id=4fc72036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc72036",
  null
  
)

export default component.exports